<div class="docs-page">
  <div class="page-header">
    <h1 class="page-title">DOCUMENTACIÓN</h1>
    <p class="page-subtitle text-muted">
      Manual técnico y diccionario de datos del sistema
    </p>
  </div>

  <div class="docs-layout">
    <aside class="docs-sidebar">
      <mat-card class="trinta-card mb-25 bg-white border-none d-block docs-sidebar-card">
        <mat-card-content class="docs-sidebar-card-content">
          @if (loading()) {
            <div class="docs-sidebar-loading">
              <mat-spinner diameter="32"></mat-spinner>
              <span>Cargando...</span>
            </div>
          } @else {
            <ng-scrollbar visibility="hover" class="docs-sidebar-scroll">
              <div class="docs-sidebar-inner">
                <div class="docs-sidebar-menu">
                  <span class="sub-title text-body">DOCUMENTOS</span>
                  @for (doc of docs(); track doc.id) {
                    <a
                      [routerLink]="['/docs', doc.id]"
                      class="sidebar-menu-link"
                      [class.active]="currentId() === doc.id"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                    >
                      <i-feather [name]="docIcon(doc)"></i-feather>
                      <span class="title">{{ doc.title }}</span>
                    </a>
                  }
                </div>
              </div>
            </ng-scrollbar>
          }
        </mat-card-content>
      </mat-card>
    </aside>

    <main class="docs-content">
      @if (loading()) {
        <mat-card class="trinta-card mb-25 bg-white border-none d-block docs-viewer-card">
          <mat-card-content class="docs-viewer-content docs-loading">
            <mat-spinner diameter="40"></mat-spinner>
            <span>Cargando documento...</span>
          </mat-card-content>
        </mat-card>
      } @else if (markdownUrl()) {
        <mat-card class="trinta-card mb-25 bg-white border-none d-block docs-viewer-card">
          <mat-card-content class="docs-viewer-content">
            <markdown [src]="markdownUrl()!" mermaid></markdown>
          </mat-card-content>
        </mat-card>
      } @else {
        <mat-card class="trinta-card mb-25 bg-white border-none d-block docs-viewer-card">
          <mat-card-content class="docs-viewer-content">
            <p class="text-muted m-0">Selecciona un documento en el menú izquierdo.</p>
          </mat-card-content>
        </mat-card>
      }
    </main>
  </div>
</div>
